import React, { useEffect, useContext } from 'react'

import PageLayout from '../components/templates/page-layout/page-layout'
import HomeContent from '../components/organisms/home-content/home-content'
import ParticipateSection from '../components/organisms/participate-section/participate-section'
import TopSection from '../components/organisms/top-section/top-section'
import useMediaQuery from '../utils/useMediaQuery'
import TermsSection from '../components/organisms/terms-section/terms-section'
import { Context } from '../context/app-context'

function IndexPage() {
  const isMobile = useMediaQuery()
  const { dispatch } = useContext(Context)
  const LOCALE = process.env.LOCALE;
  useEffect(() => {
    dispatch({ type: 'clear-modal' })

  }, []);
  return (
    <PageLayout>
      <HomeContent isMobile={isMobile} />
      <ParticipateSection isMobile={isMobile} />
      {LOCALE !== 'es-AR' && <TopSection isMobile={isMobile} />}
      <TermsSection />
    </PageLayout>
  )
}

export default IndexPage
